module.exports = __webpack_public_path__ + "img/R-0.d916c90a.png";